import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"

import { PootsyButton, LabeledDateTime } from "./FunctionalDesign"
import ModalLayout from "./ModalLayout"
import { PootsyRadioInputs } from "./FunctionalInputs"
import Filter from "./Filter"
import PootsyCalendar from "./PootsyCalendar"
import CompleteMonthPicker from "./CompleteMonthPicker"
import * as actions from "../actions"
import { connect } from "react-redux"

import moment from "moment"

class CustomizePDFModal extends Component {
	state = {
		codeSumsSquads: [],
		codesSumsTimeSpan: "",
		codeSumsFromDate: moment().startOf("month"),
		codeSumsToDate: moment()
			.startOf("month")
			.add(7, "days"),
		selectedPrintDate: moment(),
		workerTimesheetType: "pdf",
	}
	handleStateChange = changes => {
		this.setState({ ...changes })
	}
	handleCodeSumsSquadsFilterChange = changes => {
		this.handleStateChange({ [changes.name]: changes.value })
	}
	handleTypeChange = e => {
		console.log(e.target.value)
		this.setState({ workerTimesheetType: e.target.value })
		this.props.dispatch(
			actions.timesheetsReportTypeChange({ timesheetExportType: e.target.value })
		)
	}
	render() {
		let { t } = this.context
		let { teams, origin, toggleCustomizePDFModal } = this.props
		let {
			codeSumsFromDate,
			codeSumsToDate,
			codesSumsTimeSpan,
			codeSumsSquads,
			selectedPrintDate,
		} = this.state

		let showBetweenDatesWarning = false

		if (codesSumsTimeSpan === "between") {
			if (codeSumsFromDate.month() !== codeSumsToDate.month()) {
				showBetweenDatesWarning = true
			}
		}

		return (
			<ModalLayout
				customClass="timesheet-codes-sums-modal"
				closeModal={toggleCustomizePDFModal}
				withInputsChangeHandler={true}
				handleChanges={this.handleStateChange}
				title={t("timesheets_codes_sums_what_to_generate")}
				buttons={[
					<PootsyButton
						key="a"
						text={t("timesheet_download_codes_sums_pdf")}
						disabled={showBetweenDatesWarning}
						onClick={() =>
							this.props.onConfirm(
								codeSumsFromDate,
								codesSumsTimeSpan === "between" ? codeSumsToDate : null,
								codesSumsTimeSpan,
								codeSumsSquads,
								selectedPrintDate
							)
						}
					/>,
					<PootsyButton
						key="b"
						theme="cancel"
						text={t("cancel")}
						onClick={toggleCustomizePDFModal}
					/>,
				]}
			>
				{origin !== "workerTimesheet" && (
					<Fragment>
						<Filter
							label={t("squads")}
							name="codeSumsSquads"
							possibleValues={teams.map(entry => ({
								label: entry.attributes.name,
								value: entry.id,
							}))}
							currentFilters={this.state.codeSumsSquads}
							onChange={this.handleCodeSumsSquadsFilterChange}
						/>
						<PootsyRadioInputs
							groupName="codesSumsTimeSpan"
							groupLabel={t("timesheets_codes_sums_timespan")}
							selected={this.state.codesSumsTimeSpan}
							options={[
								{ id: "month", value: "month", label: t("by_month") },
								{ id: "week", value: "week", label: t("by_week") },
								{ id: "between", value: "between", label: t("between_dates") },
							]}
						/>
						{this.state.codesSumsTimeSpan === "week" && (
							<PootsyCalendar
								name="codeSumsFromDate"
								value={this.state.codeSumsFromDate.isoWeekday(1)}
								weekPickerMode={true}
								alwaysOpened={true}
								calendarStyle={{ top: "100%", left: 0 }}
								disableDay={d =>
									d.isAfter(
										moment()
											.startOf("month")
											.add(2, "month")
									)
								}
								onChange={this.handleStateChange}
							/>
						)}
						{this.state.codesSumsTimeSpan === "month" && (
							<CompleteMonthPicker
								currentDate={this.state.codeSumsFromDate}
								filter={m => m.isBefore(moment().add(1, "month"))}
								onChange={m => {
									this.handleStateChange({ codeSumsFromDate: m })
								}}
							/>
						)}
						{this.state.codesSumsTimeSpan === "between" && (
							<div className="between-dates">
								<div className="label">{t("from")}:</div>
								<PootsyCalendar
									name="codeSumsFromDate"
									value={codeSumsFromDate}
									onChange={this.handleStateChange}
								/>
								<div className="label">{t("to")}:</div>
								<PootsyCalendar
									name="codeSumsToDate"
									value={codeSumsToDate}
									onChange={this.handleStateChange}
								/>
							</div>
						)}
					</Fragment>
				)}
				<LabeledDateTime
					label={t("timesheet_pdf_selected_print_date")}
					showTimePicker={false}
					datePickerProps={{
						name: "selectedPrintDate",
						value: selectedPrintDate,
						onChange: this.handleStateChange,
						calendarStyle: { bottom: "200%", left: "100%", zIndex: "2" },
					}}
				/>
				{origin === "workerTimesheet" && (
					<Fragment>
						<PootsyRadioInputs
							groupName="timesheetExportType"
							groupLabel={t("timesheet_export_type")}
							selected={this.state.workerTimesheetType}
							options={[
								{ id: "pdf", value: "pdf", label: "pdf" },
								{ id: "xlsx", value: "xlsx", label: "xlsx" },
							]}
							onChange={this.handleTypeChange}
						/>
					</Fragment>
				)}
				{showBetweenDatesWarning && (
					<div className="warning">Dates shoud be within the same month.</div>
				)}
			</ModalLayout>
		)
	}
}

CustomizePDFModal.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	timesheetsComponent: state.redComponents.timesheetsComponent,
})
export default connect(mapStateToProps)(CustomizePDFModal)
